/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface GeoLocation {
  /** Latitude of the location */
  lat?: number;
  /** Longitude of the location */
  long?: number;
}
